module.exports = __webpack_public_path__ + "static/media/daisy-ridley-icon.da9ebd5d.jpg";